import {
  AUTHZ_BILLING_PLANS_PERMISSIONS,
  AUTHZ_BULK_PAY_PERMISSIONS,
  AUTHZ_FEATURES,
  AUTHZ_INCENTIVE_PERMISSIONS,
  AUTHZ_LIMIT_STORE_PERMISSIONS,
  AUTHZ_SLAB_PERMISSIONS,
  AUTHZ_SUBSCRIPTION_PERMISSIONS,
  LEGACY_BILLING_PLAN_PERMISSIONS,
  LEGACY_BULK_PAY_PERMISSIONS,
  LEGACY_INCENTIVE_PERMISSIONS,
  LEGACY_LIMIT_STORE_PERMISSIONS,
  LEGACY_SLAB_PERMISSIONS,
  LEGACY_SUBSCRIPTION_PERMISSIONS,
} from '../constants/permissions';

export function permissionsForFeature(
  feature: string,
  authzPanels: string[] = []
): Record<string, string> | null {
  const useAuthz = (authzPanels || []).includes(feature);
  if (feature === AUTHZ_FEATURES.INCENTIVE) {
    return useAuthz ? AUTHZ_INCENTIVE_PERMISSIONS : LEGACY_INCENTIVE_PERMISSIONS;
  }
  if (feature === AUTHZ_FEATURES.SLAB) {
    return useAuthz ? AUTHZ_SLAB_PERMISSIONS : LEGACY_SLAB_PERMISSIONS;
  }
  if (feature === AUTHZ_FEATURES.LIMIT_STORE) {
    return useAuthz ? AUTHZ_LIMIT_STORE_PERMISSIONS : LEGACY_LIMIT_STORE_PERMISSIONS;
  }
  if (feature === AUTHZ_FEATURES.SUBSCRIPTION) {
    return useAuthz ? AUTHZ_SUBSCRIPTION_PERMISSIONS : LEGACY_SUBSCRIPTION_PERMISSIONS;
  }
  if (feature === AUTHZ_FEATURES.BILLING_PLANS) {
    return useAuthz ? AUTHZ_BILLING_PLANS_PERMISSIONS : LEGACY_BILLING_PLAN_PERMISSIONS;
  }
  if (feature === AUTHZ_FEATURES.BULK_PAY) {
    return useAuthz ? AUTHZ_BULK_PAY_PERMISSIONS : LEGACY_BULK_PAY_PERMISSIONS;
  }
  return null;
}

export function permissionSlugs(
  feature: string,
  actions: string[],
  authzPanels: string[] = []
): string[] {
  const permissionMapping = permissionsForFeature(feature, authzPanels);
  if (!permissionMapping) {
    return actions || [];
  }
  return (actions || []).map((action) => permissionMapping[action]).filter(Boolean);
}
